import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';


import { Observable } from 'rxjs-compat/Observable'
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { CoreApiConfiguration } from '../coreApiConfiguration';
import { VitalSigns } from "app/shared/models/core/vital-Signs";

@Injectable()
export class WhatsAppMessageLogService extends ServiceBase {
    private actionUrl: string;
    private _url: string;
    private _getWhatsAppMessageLog: string;


    constructor(private _http: HttpClient, private _configuration: CoreApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._url = this.actionUrl + _configuration.WhatsAppMessageLog.url;
        this._getWhatsAppMessageLog = this.actionUrl + _configuration.WhatsAppMessageLog.get;
    }
    getWhatsAppMessageLog(request: any): Observable<any> {
        return this._http.get<any>(this._getWhatsAppMessageLog, {
            params: request
        });
    }
}